import React, {useMemo} from 'react';
import {Box, Grid} from '@mui/material';
import {mainPlanTypeType} from '../recommendFields';
import {transferAmountField as recommendAmountField} from '../../RecommendsTransfer/transferFields';
import {PotDetails} from '../../../../schema-types/PotDetails';
import AutoField from '../../../../components/AutoForm/AutoFieldNew';
import {useRecommendContext} from '../CreateRecommendHelpers';

import {PlanFeesField} from '../PlanFees';
import {hasWrapper} from './utils';

export const TransferNotSubplanDestinationAmounts = ({
  potInner,
  formikKeyPrefix,
  disabled,
  mainPlanType,
}: {
  potInner: PotDetails;
  formikKeyPrefix: string;
  disabled: boolean;
  mainPlanType: mainPlanTypeType;
}) => {
  const {recommendDetails} = useRecommendContext();
  const potWrapper = useMemo(() => {
    return recommendDetails?.pots?.find((curr) => curr.pot?.id === potInner.id);
  }, [recommendDetails, potInner]);

  return (
    <Box mt={1}>
      <Grid container alignContent="flex-start" direction="row" spacing={3}>
        <Grid item xs={6}>
          <AutoField
            field={{
              ...recommendAmountField,
              allowZero: true,
              canBeEmpty: true,
              disabled: true,
              id: `transfer.combinedClientOneOffMovingAmount`,
              label: `Single Amount${mainPlanType === 'pension' ? ' (Gross)' : ''}`,
            }}
          />
        </Grid>

        <Grid item xs={12}>
          <PlanFeesField
            pot={potInner}
            inModify={false}
            hasSubplan={hasWrapper(mainPlanType)}
            requiresMandate={false}
            productId={potWrapper?.pot?.productName?.id}
            providerId={potWrapper?.pot?.productProvider?.id}
            formikKeyPrefixWithoutFee={formikKeyPrefix}
            disabled
            helperText="Cannot edit existing ongoing fee using this requirement"
            isSaltus={!!potWrapper?.pot?.productProvider?.isSaltus}
          />
        </Grid>
      </Grid>
    </Box>
  );
};
